import React, {useContext, useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {DownloadRounded} from "@mui/icons-material";
import {useMutation} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {fetchExpiredAttachmentsDownload} from "../../services/http.services";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import CustomLoader from "../../../../util/component/CustomLoader";
import { Attachment } from "../../models/models";

const DownloadAttachment = (props: {attachment: Attachment}) => {
    const {t} = useTranslation(['expiredManagement', 'translation']);
    const [downloadFileName, setDownloadFileName] = useState<string | null>(null);
    const {dispatchGlobalData} = useContext(GlobalContext);

    const viewErrorMessage = (message: string, type = snackbarTypes.error) => {
        dispatchGlobalData({
            type: 'SET_SNACKBAR',
            payload: {
                snackbar: {
                    message: t(message, t('common.message.error.tryLater')),
                    type: type,
                    show: true,
                    autoClose: true,
                }
            }
        });
    }

    const downloadAttachmentMutation = useMutation(
        fetchExpiredAttachmentsDownload,
        {
            onSuccess: async (response) => {
                if (!!response) {
                    const blob = new Blob([response]);
                    const pdfURL = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    document.body.append(link);
                    link.href = pdfURL;
                    if (!!downloadFileName) {
                        link.download = downloadFileName || '';
                    }
                    link.click();
                    setDownloadFileName(null);
                }
            },
            onError: (error: any) => {
                viewErrorMessage(`common.message.error.getBlob.${error?.response?.status}`);
            }
        });

    const downloadAttachment = async (e: React.BaseSyntheticEvent) => {
        if (!!props.attachment) {
            await setDownloadFileName(props.attachment.filename);
            downloadAttachmentMutation.mutate(props.attachment.code);
        }
    }

    return (
        <>
            <Tooltip title={t('common.button.download')} arrow>
                <IconButton color={'secondary'} onClick={(e) => downloadAttachment(e)}>
                    <DownloadRounded />
                </IconButton>
            </Tooltip>

            <CustomLoader loading={downloadAttachmentMutation.isLoading}/>
        </>
    )
}

export default DownloadAttachment;